import BaseAPI from '../BaseAPI';
import { IVFSResponse } from '../types';
import { RagSearchResponse } from './types';

/**
 * RAG API
 * Handles Retrieval-Augmented Generation operations
 */
class RagAPI extends BaseAPI {
  /**
   * Ask a question to the RAG system
   * @param question - The question to ask
   */
  async search(question: string): Promise<IVFSResponse<RagSearchResponse>> {
    return this.wrapResponse<RagSearchResponse>({
      promise: this.apiInstance.get(
        `/v2/rag/search?question=${encodeURIComponent(question)}`
      ),
      errorMessage: 'Failed to search RAG system',
    });
  }
}

export default RagAPI;
